var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLinkOffOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.241 9.041L3.4 3.2 2 4.6l6.707 6.707a4.984 4.984 0 001.464 3.521L11.2 13.8l2.122 2.121-1.736 1.736a3 3 0 01-4.37-4.107 5.018 5.018 0 01-.297-2.54l-.99.99A5 5 0 1013 19.071l1.736-1.735L20.4 23l1.4-1.4-5.677-5.678L14.7 14.5l-3.91-3.909-1.549-1.549zm2.638-.163l-1.414-1.414L13 4.93A5 5 0 0120.07 12l-1.06 1.06c.12-.85.022-1.725-.295-2.535a3 3 0 00-4.302-4.182L11.88 8.878z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 12.26l1.837 1.837a4.999 4.999 0 00-2.046-5.562L13.587 10c.3.143.58.339.828.587.471.471.753 1.06.845 1.673z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLinkOffOutline);
export default __webpack_public_path__ + "4cc0bae6525c835497f44eaead0476ae.svg";
export { ForwardRef as ReactComponent };